export default [
    {
        path: '/main',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {
          title: '天信意健险系统'
        },
        children:[
          {
            path: '/',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '意健险-控制台'
            },
          },
          {
            path: 'console',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '意健险-控制台'
            },
          },
          


        



          // {
          //   path: '/roleManagement',//角色管理
          //   name: 'roleManagement',
          //   component: () => import('@/views/main/baseSetting/roleManagement/index'),
          //   meta: {
          //     title: '意健险-角色管理'
          //   },
          // },
          {
            path: '/roleLimits',//角色菜单管理
            name: 'roleLimits',
            component: () => import('@/views/main/base/roleLimits'),
            meta: {
              title: '意健险-角色菜单管理'
            },
          },
          {
            path: '/accountManagement',//账号管理
            name: 'accountManagement',
            component: () => import('@/views/main/base/accountManagement'),
            meta: {
              title: '意健险-账号管理'
            },
          },
          {
            path: '/menuManagement',//菜单管理
            name: 'menuManagement',
            component: () => import('@/views/main/base/menuManagement'),
            meta: {
              title: '意健险-菜单管理'
            },
          },
          {
            path: '/updatePassword',//编辑密码
            name: 'updatePassword',
            component: () => import('@/views/main/base/updatePassword'),
            meta: {
              title: '意健险-编辑密码'
            },
          },


          {
            path: '/anxinCaseAdd',//安心案件管理-案件录入
            name: 'anxinCaseAdd',
            component: () => import('@/views/main/anxinCase/add'),
            meta: {
              title: '意健险-安心案件管理-案件录入'
            },
          },
          {
            path: '/insuCaseAdd',//保险公司案件管理-案件录入
            name: 'insuCaseAdd',
            component: () => import('@/views/main/anxinCase/insuadd'),
            meta: {
              title: '意健险-案件管理-案件录入'
            },
          },
          {
            path: '/anxinTask',//安心案件管理-新案件
            name: 'anxinTask',
            component: () => import('@/views/main/anxinCase/task'),
            meta: {
              title: '意健险-安心案件管理-任务列表'
            },
          },
          {
            path: '/anxinTaskDetail',//安心案件管理-任务详情
            name: 'anxinTaskDetail',
            component: () => import('@/views/main/anxinCase/taskDetail'),
            meta: {
              title: '意健险-安心案件管理-任务详情',
              // keepAlive: true // 需要缓存
            },
          },
          {
            path: '/audit',//安心案件管理-任务审核
            name: 'audit',
            component: () => import('@/views/main/anxinCase/audit'),
            meta: {
              title: '意健险-安心案件管理-任务审核'
            },
          },
          {
            path: '/auditDetail',//安心案件管理-任务详情
            name: 'auditDetail',
            component: () => import('@/views/main/anxinCase/auditDetail'),
            meta: {
              title: '意健险-安心案件管理-任务详情',
              // keepAlive: true // 需要缓存
            },
          },
          {
            path: '/allAnXinCase',//保险公司全部案件
            name: 'allAnXinCase',
            component: () => import('@/views/main/anxinCase/all'),
            meta: {
              title: '意健险-安心案件管理-全部案件',
              // keepAlive: true // 需要缓存

            },
          },
          {
            path: '/quickEntry',//保险公司全部案件
            name: 'quickEntry',
            component: () => import('@/views/main/anxinCase/quickEntry'),
            meta: {
              title: '意健险-安心案件管理-案件录入',
              // keepAlive: true // 需要缓存

            },
          },
          // {
          //   path: '/anXinCaseDetail',//保险公司全部案件
          //   name: 'anXinCaseDetail',
          //   component: () => import('@/views/main/anxinCase/detail'),
          //   meta: {
          //     title: '意健险-安心案件管理-案件详情',
          //     // keepAlive: true // 需要缓存
          //   },
          // },
          // {
          //   path: '/dispatchPerson',//派遣作业人员
          //   name: 'dispatchPerson',
          //   component: () => import('@/views/main/anxinCase/dispatchPerson'),
          //   meta: {
          //     title: '意健险-安心案件管理-派遣作业人员',
          //   },
          // },
          
          {
            path: '/company',//保险公司管理
            name: 'company',
            component: () => import('@/views/main/companyManage/company'),
            meta: {
              title: '意健险-保险公司管理'
            },
          },
          {
            path: '/companyProduct',//保险公司险种管理
            name: 'companyProduct',
            component: () => import('@/views/main/companyManage/companyProduct'),
            meta: {
              title: '意健险-保险公司险种'
            },
          },

          {
            path: '/organizationManage',//机构管理
            name: 'organizationManage',
            component: () => import('@/views/main/base/organizationManage'),
            meta: {
              title: '意健险-机构管理'
            },
          },
          {
            path: '/roleManage',//角色管理
            name: 'roleManage',
            component: () => import('@/views/main/base/roleManage'),
            meta: {
              title: '意健险-角色管理'
            },
          },
          {
            path: '/userManage',//人员管理
            name: 'userManage',
            component: () => import('@/views/main/base/userManage'),
            meta: {
              title: '意健险-人员管理'
            },
          },
          


          {
            path: '/task1-1',//任务列表
            name: 'task1-1',
            component: () => import('@/views/main/anxinCase/task/index1-1'),
            meta: {
              title: '意健险-任务列表'
            },
          },
          {
            path: '/task1-2',//任务列表
            name: 'task1-2',
            component: () => import('@/views/main/anxinCase/task/index1-2'),
            meta: {
              title: '意健险-任务列表'
            },
          },
          {
            path: '/task1-3',//任务列表
            name: 'task1-3',
            component: () => import('@/views/main/anxinCase/task/index1-3'),
            meta: {
              title: '意健险-任务列表'
            },
          },
          {
            path: '/task1-4',//任务列表
            name: 'task1-4',
            component: () => import('@/views/main/anxinCase/task/index1-4'),
            meta: {
              title: '意健险-任务列表'
            },
          },
          // {
          //   path: '/task1-4(2)',//任务列表
          //   name: 'task1-4(2)',
          //   component: () => import('@/views/main/anxinCase/task/index1-4(2)'),
          //   meta: {
          //     title: '意健险-任务列表'
          //   },
          // },
          {
            path: '/task1-4(3)',//任务列表
            name: 'task1-4(3)',
            component: () => import('@/views/main/anxinCase/task/index1-4(3)'),
            meta: {
              title: '意健险-任务列表'
            },
          },
          // {
          //   path: '/task1-5',//任务列表
          //   name: 'task1-5',
          //   component: () => import('@/views/main/anxinCase/task/index1-5'),
          //   meta: {
          //     title: '意健险-任务列表'
          //   },
          // },
          // {
          //   path: '/task1-6',//任务列表
          //   name: 'task1-6',
          //   component: () => import('@/views/main/anxinCase/task/index1-6'),
          //   meta: {
          //     title: '意健险-任务列表'
          //   },
          // },
          // {
          //   path: '/task1-7',//任务列表
          //   name: 'task1-7',
          //   component: () => import('@/views/main/anxinCase/task/index1-7'),
          //   meta: {
          //     title: '意健险-任务列表'
          //   },
          // },
          {
            path: '/task1-8',//任务列表
            name: 'task1-8',
            component: () => import('@/views/main/anxinCase/task/index1-8'),
            meta: {
              title: '意健险-任务列表'
            },
          },
          {
            path: '/muchWorkAudit',//多地作业审核
            name: 'muchWorkAudit',
            component: () => import('@/views/main/anxinCase/task/muchWorkAudit'),
            meta: {
              title: '意健险-多地作业审核'
            },
          },
          
         

          


          {
            path: '/task2-1',//任务列表-新任务
            name: 'task2-1',
            component: () => import('@/views/main/anxinCaseJG/task/index1-1'),
            meta: {
              title: '意健险-任务列表-新任务'
            },
          },
          {
            path: '/task2-2',//任务列表-待派工
            name: 'task2-2',
            component: () => import('@/views/main/anxinCaseJG/task/index1-2'),
            meta: {
              title: '意健险-任务列表-待派工'
            },
          },
          {
            path: '/task2-3',//任务列表-调查中
            name: 'task2-3',
            component: () => import('@/views/main/anxinCaseJG/task/index1-3'),
            meta: {
              title: '意健险-任务列表-调查中'
            },
          },
          {
            path: '/task2-4',//任务列表-待审核
            name: 'task2-4',
            component: () => import('@/views/main/anxinCaseJG/task/index1-4'),
            meta: {
              title: '意健险-任务列表-待审核'
            },
          },
          {
            path: '/task2-4(2)',//任务列表-待审核
            name: 'task2-4(2)',
            component: () => import('@/views/main/anxinCaseJG/task/index1-4(2)'),
            meta: {
              title: '意健险-任务列表-待审核'
            },
          },
          {
            path: '/task2-5',//任务列表-已提交
            name: 'task2-5',
            component: () => import('@/views/main/anxinCaseJG/task/index1-5'),
            meta: {
              title: '意健险-任务列表-已提交'
            },
          },
          {
            path: '/task2-6',//任务列表-已通过
            name: 'task2-6',
            component: () => import('@/views/main/anxinCaseJG/task/index1-6'),
            meta: {
              title: '意健险-任务列表-已通过'
            },
          },
          {
            path: '/task2-7',//任务列表-审核退回
            name: 'task2-7',
            component: () => import('@/views/main/anxinCaseJG/task/index1-7'),
            meta: {
              title: '意健险-任务列表-审核退回'
            },
          },
          {
            path: '/task2-8',//任务列表-全部
            name: 'task2-8',
            component: () => import('@/views/main/anxinCaseJG/task/index1-8'),
            meta: {
              title: '意健险-任务列表-全部'
            },
          },
          {
            path: '/indexZY',//展业机构
            name: 'indexZY',
            component: () => import('@/views/main/anxinCaseJG/task/indexZY'),
            meta: {
              title: '意健险-展业机构'
            },
          },
          {
            path: '/insuplist',//展业机构
            name: 'insuplist',
            component: () => import('@/views/main/anxinCaseJG/task/insuplist'),
            meta: {
              title: '意健险-展业机构'
            },
          },
          {
            path: '/inupalllist',//展业机构
            name: 'inupalllist',
            component: () => import('@/views/main/anxinCaseJG/task/inupalllist'),
            meta: {
              title: '意健险-展业机构'
            },
          },
          {
            path: '/auditZYCase',//展业机构
            name: 'auditZYCase',
            component: () => import('@/views/main/anxinCaseJG/task/auditZYCase'),
            meta: {
              title: '意健险-展业机构'
            },
          },
          {
            path: '/dhxwtzt',//待回销委托主体
            name: 'dhxwtzt',
            component: () => import('@/views/main/anxinCaseJG/task/dhxwtzt'),
            meta: {
              title: '意健险-待回销委托主体'
            },
          },

          {
            path: '/task3-1',//任务列表-新任务
            name: 'task3-1',
            component: () => import('@/views/main/anxinCaseRY/task/index1-1'),
            meta: {
              title: '意健险-任务列表-新任务'
            },
          },
          {
            path: '/task3-2',//任务列表-调查中
            name: 'task3-2',
            component: () => import('@/views/main/anxinCaseRY/task/index1-2'),
            meta: {
              title: '意健险-任务列表-调查中'
            },
          },
          {
            path: '/task3-3',//任务列表-已提交
            name: 'task3-3',
            component: () => import('@/views/main/anxinCaseRY/task/index1-3'),
            meta: {
              title: '意健险-任务列表-已提交'
            },
          },
          {
            path: '/task3-4',//任务列表-已通过
            name: 'task3-4',
            component: () => import('@/views/main/anxinCaseRY/task/index1-4'),
            meta: {
              title: '意健险-任务列表-已通过'
            },
          },
          {
            path: '/task3-5',//任务列表-审核退回
            name: 'task3-5',
            component: () => import('@/views/main/anxinCaseRY/task/index1-5'),
            meta: {
              title: '意健险-任务列表-审核退回'
            },
          },
          {
            path: '/task3-6',//任务列表-全部
            name: 'task3-6',
            component: () => import('@/views/main/anxinCaseRY/task/index1-6'),
            meta: {
              title: '意健险-任务列表-全部'
            },
          },
          {
            path: '/taskRYDetail',//任务详情
            name: 'taskRYDetail',
            component: () => import('@/views/main/anxinCaseRY/detail'),
            meta: {
              title: '意健险-任务详情'
            },
          },
          {
            path: '/taskRYAllDetail',//任务详情
            name: 'taskRYAllDetail',
            component: () => import('@/views/main/anxinCaseRY/allDetail'),
            meta: {
              title: '意健险-任务详情'
            },
          },
          {
            path: '/taskJgDetail',//任务详情
            name: 'taskJgDetail',
            component: () => import('@/views/main/anxinCaseJG/detail'),
            meta: {
              title: '意健险-任务详情'
            },
          },
          {
            path: '/taskJgAllDetail',//任务详情
            name: 'taskJgAllDetail',
            component: () => import('@/views/main/anxinCaseJG/allDetail'),
            meta: {
              title: '意健险-任务详情'
            },
          },
          {
            path: '/auditTaskJgDetail',//任务详情
            name: 'auditTaskJgDetail',
            component: () => import('@/views/main/anxinCaseJG/auditDetail'),
            meta: {
              title: '意健险-任务详情'
            },
          },


          {
            path: '/addCase',//新增案件
            name: 'addCase',
            component: () => import('@/views/main/anxinCase/add'),
            meta: {
              title: '意健险-新增案件'
            },
          },
          {
            path: '/editCase',//新增案件
            name: 'editCase',
            component: () => import('@/views/main/anxinCase/edit'),
            meta: {
              title: '意健险-编辑案件'
            },
          },

          {
            path: '/dataDay',//日报统计
            name: 'dataDay',
            component: () => import('@/views/main/data/day'),
            meta: {
              title: '意健险-日报统计'
            },
          },
          {
            path: '/dataMonth',//月报统计
            name: 'dataMonth',
            component: () => import('@/views/main/data/month'),
            meta: {
              title: '意健险-月报统计'
            },
          },
          {
            path: '/quality',//安心保险调查作业质量报表
            name: 'quality',
            component: () => import('@/views/main/data/quality'),
            meta: {
              title: '意健险-安心保险调查作业质量报表'
            },
          },
          
          {
            path: '/dayTabel',//意健险日报表格
            name: 'dayTabel',
            component: () => import('@/views/main/data/dayTabel'),
            meta: {
              title: '意健险-意健险日报表格'
            },
          },

          {
            path: '/informationManage',//派驻人员信息管理
            name: 'informationManage',
            component: () => import('@/views/main/personAccreditManage/informationManage'),
            meta: {
              title: '意健险-派驻人员信息管理'
            },
          },
          {
            path: '/freeRecord',//公估费记录
            name: 'freeRecord',
            component: () => import('@/views/main/personAccreditManage/freeRecord'),
            meta: {
              title: '意健险-公估费记录'
            },
          },
          {
            path: '/petShop',//宠物店资料收集
            name: 'petShop',
            component: () => import('@/views/main/petShop/index'),
            meta: {
              title: '意健险-宠物店资料收集'
            },
          },

          {
            path: '/drugs_zhong',//中药库
            name: 'drugs_zhong',
            component: () => import('@/views/main/drugs/zhong'),
            meta: {
              title: '意健险-中药库'
            },
          },

          {
            path: '/drugs_xi',//西药库
            name: 'drugs_xi',
            component: () => import('@/views/main/drugs/xi'),
            meta: {
              title: '意健险-西药库'
            },
          },

          {
            path: '/drugs_yi',//医疗服务价格项目
            name: 'drugs_yi',
            component: () => import('@/views/main/drugs/yi'),
            meta: {
              title: '意健险-医疗服务价格项目'
            },
          },

          {
            path: '/drugs_zhen',//诊疗项目
            name: 'drugs_zhen',
            component: () => import('@/views/main/drugs/zhen'),
            meta: {
              title: '意健险-诊疗项目'
            },
          },
          {
            path: '/drugs_hospital',//医院库
            name: 'drugs_hospital',
            component: () => import('@/views/main/drugs/hospital'),
            meta: {
              title: '意健险-医院库'
            },
          },
          {
            path: '/medical',//医保政策库
            name: 'medical',
            component: () => import('@/views/main/drugs/medical'),
            meta: {
              title: '意健险-医保政策库'
            },
          },
          
          
          // {
          //   path: '/taskPersonDetail',//任务详情
          //   name: 'taskPersonDetail',
          //   component: () => import('@/views/main/anxinCase/taskPersonDetail'),
          //   meta: {
          //     title: '意健险-任务详情'
          //   },
          // },


          
        ]
          
        
      },

]